module.exports = __webpack_public_path__ + "img/logo.beeac3d8.svg";